<template>
<div class="callout">
    <div class="callout-img">
   <!--  <div class="callout-img" :style="`background-image:url(${staticAssetPath}/img/ornish/${calloutImgName})`"> -->
         <img class="lazyload" :alt="`${alternativeText}`" border="0" :data-src="`${staticAssetPath}/img/ornish/${calloutImgName}`" />
    
        <div class="callout-text">
            <div class="callout-header" v-html="calloutHeaderText"></div>
            <div class="callout-desc" v-html="calloutDescText"> </div>
        </div>
        <div class="callout-overlay">
            <img class="lazyload" :alt="`${alternativeTextOverlay}`" border="0" :data-src="`${staticAssetPath}/img/ornish/${calloutOverlayImgName}`" />
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'OrnishImpactForProvidersPatientsCallout',
  data () {
        return {
          staticAssetPath: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL,
        }
    },
  props: {
    calloutImgName: {
        type: String,
        default: ''
    },
    calloutHeaderText: {
        /* type: String,
        default: '' */
    },
    calloutDescText: {
        type: String,
        default: ''
    },
    calloutOverlayImgName: {
        type: String,
        default: ''
    },
    alternativeTextOverlay: {
        type: String,
        default: ''
    },
    alternativeText: {
        type: String,
        default: ''
    }
  }
}
</script>